



























































import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import PinInput from '@/modules/shared/components/panel/PinInput.vue'
import UserPhoneVerifyForm from '@/modules/user/components/shared/phone-verification/UserPhoneVerifyForm.vue'
import UserPhoneEditForm from '@/modules/user/components/shared/phone-verification/UserPhoneEditForm.vue'
import UserPhoneVerifyButton from '@/modules/user/components/shared/phone-verification/UserPhoneVerifyButton.vue'

@Component({
  components: {
    UserPhoneVerifyButton,
    UserPhoneEditForm,
    UserPhoneVerifyForm,
    PinInput,
    AlertNotification,
    BaseButton,
    Modal,
    BaseInput,
    BaseCard
  }
})
export default class UserProfileNameForm extends Vue {
  @Prop() phone!: string
  @Prop() isVerified!: boolean
  editPhoneModal = false
}
